// src/features/audit/hooks/useAuditWorkspaceMock.ts
//
// Single read seam for the audit workspace route (/audit/:id), same
// pattern as useSecurityWorkspaceMock/useCommissionWorkspaceMock.
// Looks up the base audit record plus the per-record
// event/actor/target/metadata/timeline maps in data/audit.mock.ts by
// id. Synchronous by design (no loading/error state) — there is no
// real request happening yet, this only becomes needed once this
// wraps a real audit-detail endpoint. AuditWorkspacePage reads
// through this hook instead of importing the mock maps directly, so
// that later swap only touches this file.

import {
  auditsMock,
  auditEventMock,
  auditActorMock,
  auditTargetMock,
  auditMetadataMock,
  auditTimelineMock,
} from '../data/audit.mock';

export function useAuditWorkspaceMock(id: string | undefined) {
  const record = id ? auditsMock.find((candidate) => candidate.id === id) : undefined;

  return {
    record,
    event: id ? auditEventMock[id] : undefined,
    actor: id ? auditActorMock[id] : undefined,
    target: id ? auditTargetMock[id] : undefined,
    metadata: id ? auditMetadataMock[id] : undefined,
    timeline: id ? auditTimelineMock[id] ?? [] : [],
  };
}
